

































import { Component } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { navigatorLang } from '@/plugins/i18n';
import { Document } from '@/plugins/podolib/services/doctor';

interface IAccountTermsAndConditions extends MixinDialog {
  _open(document: Document): void;
}

@Component<IAccountTermsAndConditions>({
  mounted() {
    this.$pdc.bus!.on('account:t&c:open', this._open);
  },
  beforeDestroy() {
    this.$pdc.bus!.off('account:t&c:open', this._open);
  },
})
export default class AccountTermsAndConditions extends MixinDialog {
  document: Document = null!;

  get lang() {
    return this.$pdc.doctor!.current?.config.lang || navigatorLang();
  }

  get documents() {
    switch (this.lang) {
      case 'fr':
        return {
          [Document.TOU]: this.$pdc.helper!.fromCdn('other', `legal/TOU/20191105_TOU_PodoSmart_fr.pdf`),
          [Document.DPA]: this.$pdc.helper!.fromCdn('other', `legal/DPA/20200818_DPA_DS_ProX_fr.pdf`),
        };
      case 'de':
        return {
          [Document.TOU]: this.$pdc.helper!.fromCdn('other', `legal/TOU/20201808_TOU_PodoSmart_de.pdf`),
          [Document.DPA]: this.$pdc.helper!.fromCdn('other', `legal/DPA/20200818_DPA_DS_ProX_de.pdf`),
        };
      default:
        return {
          [Document.TOU]: this.$pdc.helper!.fromCdn('other', `legal/TOU/20191105_TOU_PodoSmart_en.pdf`),
          [Document.DPA]: this.$pdc.helper!.fromCdn('other', `legal/DPA/20200818_DPA_DS_ProX_en.pdf`),
        };
    }
  }

  get selectedDocument() {
    return this.documents[this.document];
  }

  get selectedDocumentTitle() {
    switch (this.document) {
      case Document.TOU:
        return this.$t('commons.sentences.account.terms-and-conditions.doc-tou.title');
      case Document.DPA:
        return this.$t('commons.sentences.account.terms-and-conditions.doc-dpa.title');
      default:
        return this.$t('commons.sentences.terms-conditions');
    }
  }

  _open(document: Document) {
    this.document = document;

    this.open();
  }
}
